// v2.16.0 — Modale "Offre Plateforme" pour le mode Divertissement.
// Affiche l'offre, le code promo (copiable) et un bouton de partage WhatsApp.

import { toast } from "sonner";

const TIER_LABEL = {
  partner: "🏆 PARTNER",
  premium: "💎 PREMIUM",
  basic: "✨ BASIC",
};

const TIER_BG = {
  partner: "linear-gradient(135deg, #FCD34D, #F59E0B)",
  premium: "linear-gradient(135deg, #C4B5FD, #A855F7)",
  basic:   "linear-gradient(135deg, #93C5FD, #3B82F6)",
};

export default function PlatformOfferModal({ open, onClose, item }) {
  if (!open || !item) return null;
  const tier = item.sponsored_tier || "free";
  const accent = item.accent || "#A855F7";

  const copyCode = async () => {
    if (!item.platform_offer_code) return;
    try {
      await navigator.clipboard.writeText(item.platform_offer_code);
      toast.success(`✅ Code copié : ${item.platform_offer_code}`);
    } catch (_) { toast.error("Copie impossible"); }
  };

  const shareWhatsApp = () => {
    const msg = `🎁 Offre AYA chez ${item.nom} (${item.commune_name}) : ${item.platform_offer}${item.platform_offer_code ? `\nCode promo : ${item.platform_offer_code}` : ""}\n\n📍 ${item.adresse_civ}\n📞 ${item.telephone}\n\nDécouvre plus sur AYA 🇨🇮`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <div data-testid="platform-offer-modal" onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
      zIndex: 110, display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#0F172A", border: `1px solid ${accent}66`,
        borderRadius: 14, width: "100%", maxWidth: 440, padding: 22, color: "#F1F5F9",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
          <div>
            <div style={{
              display: "inline-block", padding: "4px 10px", borderRadius: 999,
              background: TIER_BG[tier] || accent, color: "#0F172A", fontWeight: 800, fontSize: 11,
              letterSpacing: "0.05em",
            }}>{TIER_LABEL[tier] || tier.toUpperCase()}</div>
            <h3 style={{ margin: "10px 0 0 0", fontSize: 20 }}>🎁 Offre Plateforme</h3>
          </div>
          <button onClick={onClose} data-testid="platform-offer-close" style={{
            background: "transparent", border: "none", color: "#94a3b8",
            fontSize: 22, cursor: "pointer", lineHeight: 1,
          }}>✕</button>
        </div>

        <div style={{
          background: `${accent}1A`, border: `1px solid ${accent}55`,
          borderRadius: 10, padding: 14, marginBottom: 14,
        }}>
          <div style={{ fontSize: 12, color: "#cbd5e1", marginBottom: 4 }}>Chez {item.nom}</div>
          <div data-testid="platform-offer-text" style={{ fontSize: 16, fontWeight: 700, color: "#fff", lineHeight: 1.4 }}>
            {item.platform_offer}
          </div>
        </div>

        {item.platform_offer_code && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 4 }}>CODE PROMO</div>
            <div style={{ display: "flex", gap: 8, alignItems: "stretch" }}>
              <div data-testid="platform-offer-code" style={{
                flex: 1, padding: "10px 14px", background: "rgba(255,255,255,0.06)",
                border: "1px dashed rgba(255,255,255,0.25)", borderRadius: 8,
                fontFamily: "monospace", fontSize: 18, fontWeight: 800, color: "#FBBF24",
                letterSpacing: "0.1em", textAlign: "center",
              }}>{item.platform_offer_code}</div>
              <button onClick={copyCode} data-testid="platform-offer-copy-code" style={{
                background: "#FBBF24", color: "#0F172A", border: "none",
                padding: "0 14px", borderRadius: 8, cursor: "pointer", fontWeight: 800, fontSize: 13,
              }}>📋 Copier</button>
            </div>
          </div>
        )}

        <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 12, fontSize: 12, color: "#cbd5e1", lineHeight: 1.6, marginBottom: 14 }}>
          <div>📍 <code style={{ color: "#fff" }}>{item.adresse_civ}</code></div>
          <div>🕐 {item.horaires}</div>
          <div>📞 {item.telephone}</div>
        </div>

        <button data-testid="platform-offer-share-whatsapp" onClick={shareWhatsApp} style={{
          width: "100%", background: "#25D366", color: "#fff", border: "none",
          padding: "12px 16px", borderRadius: 10, cursor: "pointer", fontWeight: 700, fontSize: 14,
          display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
        }}>
          📤 Partager via WhatsApp
        </button>

        <p style={{ fontSize: 11, color: "#64748b", marginTop: 12, textAlign: "center", marginBottom: 0 }}>
          Offre valable sur présentation du code à l'établissement. Conditions selon partenaire.
        </p>
      </div>
    </div>
  );
}
